import { apiFetch } from './client';

export const registerMember = (payload) =>
  apiFetch('/auth/register', {
    method: 'POST',
    body: {
      ...payload,
      name: payload?.name || payload?.fullName || '',
      fullName: payload?.fullName || payload?.name || '',
      password_confirmation:
        payload?.passwordConfirmation ||
        payload?.confirmPassword ||
        payload?.password_confirmation ||
        payload?.password
    }
  });

export const verifyMemberRegistrationCode = (email, code) =>
  apiFetch('/auth/register/verify-code', {
    method: 'POST',
    body: { email, code }
  });

export const resendMemberRegistrationCode = (email) =>
  apiFetch('/auth/register/resend-code', {
    method: 'POST',
    body: { email }
  });

export const login = async (email, password) => {
  const data = await apiFetch('/auth/login', {
    method: 'POST',
    body: { email, password }
  });

  const token =
    data?.token ||
    data?.access_token ||
    data?.accessToken ||
    data?.data?.token ||
    data?.data?.access_token ||
    data?.data?.accessToken;
  if (token) {
    localStorage.setItem('token', token);
  }

  return data;
};

export const me = () =>
  apiFetch('/auth/me', { token: localStorage.getItem('token') });

export const logout = async () => {
  const token = localStorage.getItem('token');
  await apiFetch('/auth/logout', { method: 'POST', token });
  localStorage.removeItem('token');
};
